import React, { useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import moment from "moment";
import OpenRouteModel from "../OpenRouteModal";
import { Image } from "antd";
import OpenRouteTncModal from "../OpenRouteTncModal";

function Register(props) {
  const [errorMessage, setErrorMessage] = useState({ name: "", message: "" });
  const [isLoading, setLoading] = useState(false);
  const fields = [
    {
      name: "full_name",
      label: "Full Name (As per PAN Card)",
      type: "text",
      placeholder: "Please enter",
      required: true,
    },
    {
      name: "email_address",
      label: "Email ID",
      type: "email",
      placeholder: "Please enter",
      required: true,
    },
    {
      name: "pin_code",
      label: "PIN Code",
      type: "number",
      placeholder: "Please enter",
      required: true,
    },
    {
      name: "gender",
      label: "Gender",
      type: "select",
      options: _enum.GENDER,
      placeholder: "Please enter",
      required: true,
    },
    {
      name: "date_of_birth",
      label: "DOB",
      type: "date",
      disabledDate: (current) => {
        const today = moment();
        const maxDate = today.subtract(18, "years");
        return current && current > maxDate.endOf("day");
      },
      defaultValue: moment().subtract(18, "years"),
      placeholder: "Please enter",
      required: true,
    },
  ];

  function onRegister(e, data, form) {
    e.preventDefault();
    console.log({ data });

    let termscheckval = document.getElementById("termsCheck").checked;
    console.log({ termscheckval });

    if (!termscheckval) {
      swal2.fire({
        title:
          "Please check the 'Terms and Conditions' and 'Privacy Policy' checkbox to proceed.",
        icon: "warning",
        iconColor: "#FF4D4D",
        showCancelButton: false,
        timer: 4000,
      });
      return;
    } else if (
      data?.date_of_birth === undefined ||
      data.date_of_birth.length === 0 ||
      data.gender.length === 0
    ) {
      swal2.fire({
        title: "Please fill all required fields",
        icon: "error",
        iconColor: "#FF4D4D",
        showCancelButton: false,
        timer: 4000,
      });
      return;
    } else {
      let payload = {
        ...Object.except(data, ["date_of_birth", "termsCheck"]),
        date_of_birth: new Date(data?.date_of_birth).toISOString(),
        is_tnc_accepted: true,
      };

      console.log({ payload });

      props.apis
        .apiConnectorSignUpSubmit(payload)
        .then((res) => {
          console.log({ apiConnectorSignUpSubmit: res });
          // redirect to login page
          swal2
            .fire({
              title:
                "Sign-up Completed successfully, Please login with your registered mobile number",
              icon: "success",
              iconColor: "#008AD1",
            })
            .then((result) => {
              if (result.isConfirmed) {
                navigate("/open/connector/login");
              }
            });
          setLoading(false);
        })
        .catch((err) => {
          console.log({ OTPlogin: err });

          swal2.fire({
            title: "Sign-up failed",
            text: `${err || err.message || ""}`,
            icon: "error",
            iconColor: "#FF4D4D",
            showCancelButton: false,
            timer: 4000,
          });
          setLoading(false);
        });
    }
  }

  const closeTncModal = () => {
    document.querySelector("#tncModal #bsmodalclose").click();
  };

  const closePrivacyPolicyModal = () => {
    document.querySelector("#privacyPolicyModal #bsmodalclose").click();
  };

  return (
    <>
      <div className="page-wraper">
        <div className="browse-job login-style3">
          <div className="bg-img-fix overflow-hidden">
            <div className="parent-container row gx-0 registration_page">
              <div
                className="col-xl-6 col-lg-6 col-md-6 col-sm-12 login_img_bg"
                style={{ backgroundImage: "url(" + imagepaths.loginBg + ")" }}
              >
                <div className="logo_header ps-3">
                  <Link to={"/open/connector/login"} className="logo">
                    <img src={imagepaths.logoWithTagline} alt="" />
                  </Link>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex align-items-center">
                <div className="login-form style-2">
                  <div className="card-body">
                    <nav className="nav nav-tabs border-bottom-0">
                      <div className="tab-content w-100" id="nav-tabContent">
                        <div className="tab-pane active show fade registration_card">
                          {props.errorMessage && (
                            <div className="">{props.errorMessage}</div>
                          )}
                          {props.successMessage && (
                            <div className="">{props.successMessage}</div>
                          )}
                          <div className="w-100 text-center">
                            <Image
                              src={imagepaths.logoHome}
                              preview={false}
                              width={150}
                              className="mb-4 pointer-cursor"
                              alt="logo"
                              onClick={() => navigate("/open/connector/login")}
                            />
                          </div>
                          <h3 className="form-title text-center mb-4">
                            Tell us a bit about yourself
                          </h3>
                          <AppForm onSubmit={(...args) => onRegister(...args)}>
                            {fields.map((field, i) => {
                              return (
                                <>
                                  <div className={`col-12 col-md-12`} key={i}>
                                    <AppInput
                                      {...field}
                                      errorMessage={errorMessage}
                                    ></AppInput>
                                  </div>
                                </>
                              );
                            })}
                            <div className="col-12 col-md-12 mb-3 mt-3">
                              <span className="form-check float-start me-2">
                                <input
                                  type="checkbox"
                                  className="form-check-input mt-0"
                                  id="termsCheck"
                                  name="termsCheck"
                                />
                                <label
                                  className="form-check-label d-unset"
                                  htmlFor="termsCheck"
                                >
                                  I have read and agreed to the
                                  <a
                                    href="#"
                                    data-bs-toggle="modal"
                                    data-bs-target="#tncModal"
                                    className="text-primary ms-2 link-underline-primary"
                                    style={{textDecoration: "underline"}}
                                  >
                                    Wealth Avenue T&C
                                  </a>
                                  <span className="mx-1">&</span>
                                  <a 
                                    href="#"
                                    data-bs-toggle="modal"
                                    data-bs-target="#privacyPolicyModal"
                                    className="text-primary"
                                    style={{textDecoration: "underline"}}>Privacy Policy.</a>
                                </label>
                              </span>
                            </div>
                            <div className="nav_container d-flex flex-column">
                              <button
                                type="submit"
                                className="btn btn-primary button-md btn-block mb-3"
                                disabled={isLoading}
                              >
                                {isLoading ? "Loading…" : "Proceed"}
                              </button>
                              <Link
                                to={"/open/connector/login"}
                                className="btn btn-primary-lite button-md btn-block bg-transparent"
                              >
                                Cancel
                              </Link>
                            </div>
                          </AppForm>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OpenRouteTncModal
        id="tncModal"
        className="modal-lg openRouteModel"
        modalSize="modal-lg"
        title="Terms and Conditions"
        submitText="Understood"
        modaltype="centeredmodal"
        onClose={() => closeTncModal()}
        footer={true}
        okText="Understood"
      />
      <OpenRouteModel
        id="privacyPolicyModal"
        className="modal-lg openRouteModel"
        modalSize="modal-lg"
        title="Privacy Policy"
        submitText="Understood"
        modaltype="centeredmodal"
        onClose={() => closePrivacyPolicyModal()}
        footer={true}
        okText="Understood"
      />
    </>
  );
}

export default constore(Register);
